import React from 'react'
import {Icon} from '@chakra-ui/react'

const GalleryBucketIntroIcon = (props) => {
    return (
        <Icon viewBox="0 0 14 14" fill="none" {...props}>
            <line
                opacity="0.1"
                x1="2"
                y1="10.4"
                x2="12"
                y2="10.4"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <path opacity="0.1" d="M1 7L13 7" stroke="currentColor" strokeWidth="1.2" />
            <line
                opacity="0.1"
                x1="2"
                y1="3.9"
                x2="12"
                y2="3.9"
                stroke="currentColor"
                strokeWidth="1.2"
            />
            <path
                d="M5.25 5.25172C5.24969 5.1482 5.27693 5.04646 5.32894 4.95694C5.38094 4.86743 5.45582 4.79337 5.5459 4.74236C5.63599 4.69135 5.73802 4.66523 5.84154 4.66668C5.94505 4.66814 6.04631 4.69711 6.13492 4.75064L9.04984 6.49889C9.13662 6.55061 9.20848 6.62398 9.25838 6.71182C9.30828 6.79965 9.33452 6.89895 9.33452 6.99997C9.33452 7.10099 9.30828 7.20028 9.25838 7.28812C9.20848 7.37596 9.13662 7.44933 9.04984 7.50105L6.13492 9.2493C6.04627 9.30285 5.94495 9.33183 5.84139 9.33326C5.73783 9.33469 5.63575 9.30852 5.54565 9.25744C5.45555 9.20636 5.38067 9.13222 5.32871 9.04262C5.27676 8.95302 5.24959 8.85121 5.25 8.74764V5.25172Z"
                fill="currentColor"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M7.00033 12.8334C10.222 12.8334 12.8337 10.2217 12.8337 7.00002C12.8337 3.77836 10.222 1.16669 7.00033 1.16669C3.77866 1.16669 1.16699 3.77836 1.16699 7.00002C1.16699 10.2217 3.77866 12.8334 7.00033 12.8334Z"
                stroke="currentColor"
                strokeWidth="1.2"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </Icon>
    )
}

export default GalleryBucketIntroIcon
